module.exports = __webpack_public_path__ + "img/vertical_3_6_0.62a7f6ae.png";